import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import {
  Avatar,
  ImageCropper,
  Modal,
  useFileUpload,
  useToggle,
} from '../../components';
import { RootState } from '../../store/store';
import { getUsers } from '../../store/users/users.actions';
import { EditIcon } from '../../components/Icons/EditIcon';
import { updateOrganization } from '../../store/orgs/orgs.actions';
import { AddOrganization } from '../Organizations/components/AddOrganization/AddOrganization';

export const MyOrganization: React.FC = (): JSX.Element => {
  const {
    handleUpload,
    file,
    removeFile,
    croppedImage,
    saveCroppedImage,
  } = useFileUpload();

  const { user, org } = useSelector((state: RootState) => state.auth);
  const { users } = useSelector((state: RootState) => state.users);
  const owner = users.find((u) => u.role === 'owner');
  const admins = users.filter((u) => u.role === 'admin');
  const dispatch = useDispatch();
  const { open: editOpen, toggle: toggleEdit } = useToggle(false);

  useEffect(() => {
    if (!users.length) dispatch(getUsers(org?.orgId || ''));
  });

  useEffect(() => {
    if (croppedImage)
      dispatch(
        updateOrganization({ avatar: croppedImage }, user?.orgId || '', true)
      );
  }, [croppedImage, dispatch, user?.orgId]);

  return (
    <div className="account">
      <AddOrganization
        isMyOrgEdit
        org={org}
        open={editOpen}
        onClose={toggleEdit}
      />
      <Modal
        open={!!file}
        onClose={removeFile}
        title="Upload a photo"
        height="570px"
      >
        <ImageCropper
          onSave={saveCroppedImage}
          onCancel={removeFile}
          image={file || ''}
        />
      </Modal>
      <div className="account__profile">
        <div className="account__profile-avatar">
          <Avatar
            org={org}
            image={org?.avatar}
            onUpload={handleUpload}
            hasUpload
          />
        </div>

        <div className="account__profile-content-thirdColumn">
          <h3 className="account__profile-content-thirdColumn__title">
            {org?.name} <EditIcon onClick={toggleEdit} />
          </h3>
          <h4>{org?.location}</h4>
          <div className="account__profile-content-thirdColumn__email">
            {user?.email}
          </div>
          <div className="account__profile-content-thirdColumn__email">
            {org?.url}
          </div>

          <div className="account__profile-content-thirdColumn__org">
            <div>
              <span className="account__profile-content-thirdColumn__org-start">
                Owner:
              </span>{' '}
              {owner?.firstName} {owner?.lastName}
            </div>
            <div>
              <span className="account__profile-content-thirdColumn__org-start">
                Admins:{' '}
              </span>
              {admins.map((admin) => admin.name).join(', ') ||
                ' There are no admins currently'}
            </div>
            <div>
              <span className="account__profile-content-thirdColumn__org-start">
                Members:{' '}
              </span>
              {users.length}
            </div>
            <div>
              <span className="account__profile-content-thirdColumn__org-start">
                Created:{' '}
              </span>
              {moment(org?.createdAt).format('LL')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
